// src/pages/CostCenters/DeleteEmployeeModal/index.jsx

import React, { useState, useEffect, useMemo } from "react"
import PropTypes from "prop-types"
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Form,
  Table

} from "reactstrap"
import i18n from "../../../i18n"
import * as Yup from 'yup';
import { useFormik } from "formik";
import SimpleAlertError from '../../../components/Alerts/SimpleAlertError'
import { delCostCenterEmployees } from '../../../helpers/api_rombo_helper'

const DeleteEmployeeModal = ({
  selectCostCenter,
  isOpen,
  toggle,
  setShowAlertSuccess,
  setDeleteEmployeeModal,
  setTextHeader,
  setTextBody,
  selectEmployee,
  setReloadCostCenterEmployees,
  reloadCostCenterEmployees,
  token
}) => {
  const [errorAlert, setErrorAlert] = useState(false)
  const [errorAlertMessage, setErrorAlertMessage] = useState(null)

  useEffect(() => {
    // vacía, o úsala si necesitas reaccionar a selectEmployee
  }, [selectEmployee])

  const onClickAccept = () => {
    const body = { employees: [{ id: selectEmployee.idDB }] }
    delCostCenterEmployees(token, selectCostCenter.id, body)
      .then(() => {
        setShowAlertSuccess(true)
        setDeleteEmployeeModal(false)
        setReloadCostCenterEmployees(!reloadCostCenterEmployees)
        setTextHeader(i18n.t("DeletedEmployees"))
        setTextBody(
          i18n.t("SuccessDeleteEmployees", {
            name: selectCostCenter.name,
            number: 1
          })
        )
      })
      .catch((error) => {
        console.error("Error - delCostCenterEmployees - ", error)
        const msg = error.response?.data?.detail || error.message
        setErrorAlertMessage(error.code === 500 ? i18n.t("NetworkError") : msg)
        setErrorAlert(true)
      })
  }

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus
      centered
      className="RequestModal"
      style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      toggle={toggle}
      backdrop="static"
      id="staticBackdrop"
      size="lg"
    >
      <div>
        <p className="cancellation-title">
          {i18n.t("DeleteEmployee")}
        </p>
        <p className="cancellation-confirmation">
          {i18n.t("Confirmation")}
        </p>
        <div className="modal-separator" />
        <ModalBody className="mt-0 pt-0">
          <SimpleAlertError
            errorAlert={errorAlert}
            setErrorAlert={setErrorAlert}
            text={errorAlertMessage}
          />
          <Row>
            <p className="cancellation-text">
              {i18n.t("TextDeleteEmployee")}
            </p>
            <p className="cancellation-text">
              {selectEmployee.name} ({selectEmployee.email})
            </p>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn-danger"
            type="button"
            onClick={onClickAccept}
          >
            {i18n.t("Accept")}
          </Button>
          <Button
            className="btn-light"
            type="button"
            onClick={toggle}
          >
            {i18n.t("GoBack")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

DeleteEmployeeModal.propTypes = {
  selectCostCenter: PropTypes.object,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  setShowAlertSuccess: PropTypes.func,
  setDeleteEmployeeModal: PropTypes.func,
  setTextHeader: PropTypes.func,
  setTextBody: PropTypes.func,
  selectEmployee: PropTypes.object,
  setReloadCostCenterEmployees: PropTypes.func,
  reloadCostCenterEmployees: PropTypes.bool,
  token: PropTypes.object
}

export default DeleteEmployeeModal